import { HeadingNodeSpec, HEADING_KEY } from '@techchange/pm-specs';

import HeadingDropdown from './components/HeadingDropdown';
import headingKeymap from './plugins/keymap';

const heading = {

	nodes() {

		return {
			[HEADING_KEY]: HeadingNodeSpec,
		};

	},

	plugins() {

		return [headingKeymap];

	},

	toolbarButtons() {

		return [{ Button: HeadingDropdown, key: 'HeadingDropdown' }];

	},

};

export default heading;
